import { api } from "./api";

export const landingForm = api.injectEndpoints({
  endpoints: builder => ({
    submitLanding: builder.mutation({
      query: ({
        name,
        email,
        benefits,
      }) => {
        return {
          url: `${process.env.REACT_APP_API_URL}/users/landing-form`,
          method: 'POST',
          body: {
            name,
            email,
            benefits,
          },
        }
      },
    }),
  })
});

export const {
  useSubmitLandingMutation
} = landingForm;
